import { Box, Theme, useMediaQuery } from "@mui/material";

import { LoaderProps, Loader } from "../Loader";

interface Props extends LoaderProps {
  isFixed?: boolean;
}

export function LoadingFrame(props: Props) {
  const isFixed = props.isFixed ?? true;
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

  return (
    <Box
      {...(isFixed
        ? {
            position: "fixed",
            top: 0,
            left: 0,
          }
        : {})}
      width="100%"
      height="100%"
      px={2}
      zIndex={2000}
      pt={isDesktop ? 14 : 4}
      sx={{
        backgroundColor: "background.default",
      }}>
      <Loader {...props} />
    </Box>
  );
}
